import { ChangeDetectionStrategy, Component, Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ISignedUrlResult, StylesheetService } from '@shared/services/stylesheet.service';
import { take } from 'rxjs';
import { FileuploadComponent } from '../../shared/components/fileupload/fileupload.component';
import { downloadFile } from '../../shared/helpers';
import { StylingValidatorService } from '../../shared/services/filevalidators/stylingvalidator.service';

@Component({
	selector: 'app-drawings',
	templateUrl: './drawings.component.html',
	styleUrl: './drawings.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DrawingsComponent {
	public isLoading: boolean = false;

	constructor(
		private stylesheetService: StylesheetService,
		public dialog: MatDialog,
		private injector: Injector,
	) {}

	// Called from the template when the Color -> Download button is clicked.
	downloadColor(): void {
		this.stylesheetService
			.getStylingUrl('GET', 'color')
			.pipe(take(1))
			.subscribe({
				next: (res: ISignedUrlResult) => downloadFile(res.result.url, 'color.css'),
				error: (err) => console.error('Failed to get download URL:', err),
			});
	}

	// Called from the template when the Custom -> Download button is clicked.
	downloadCustom(): void {
		this.stylesheetService
			.getStylingUrl('GET', 'custom')
			.pipe(take(1))
			.subscribe({
				next: (res: ISignedUrlResult) => downloadFile(res.result.url, 'custom.css'),
				error: (err) => console.error('Failed to get download URL:', err),
			});
	}

	uploadColor(): void {
		this.uploadStyling('color');
	}

	uploadCustom(): void {
		this.uploadStyling('custom');
	}

	uploadStyling(type: string) {
		this.dialog.open(FileuploadComponent, {
			width: '450px',
			data: {
				headingKey: `administration.drawings.upload.title.${type}`,
				subHeadingKey: 'administration.drawings.upload.subtitle',
				confirmButtonKey: 'administration.drawings.upload.button',
				notificationHeader: 'administration.drawings.upload.notification.success.header',
				notificationContent: 'administration.drawings.upload.notification.success.content',
				notificationErrorHeader: 'administration.drawings.upload.notification.error.header',
				notificationErrorContent: 'administration.drawings.upload.notification.error.content',
				notificationClientErrorHeader: 'administration.drawings.upload.notification.clientError.header',
				notificationClientErrorContent: 'administration.drawings.upload.notification.clientError.content',
				detailedClientErrorMessage: 'administration.drawings.upload.detailed-client-error-message',
				allowedFileTypes: ['.css'],
				data: type,
				validatorService: this.injector.get(StylingValidatorService),
				optionalFields: [],
			},
		});
	}
}
